/**
 * `databaseEngineIdToSqlEngine` — maps the connection-store's
 * `DatabaseEngineId` (which uses `'pgsql'`) to the grammar-layer `SqlEngine`
 * (which uses `'postgres'`). Returns `null` for engines without a Resolver
 * projector (e.g. `'mock'`, `'kusto'`).
 *
 * Inverse of [`sqlEngineToDatabaseEngineId`](./sqlEngineToDatabaseEngineId.ts).
 * Shared single source of truth kept as a dep-free leaf util (type-only
 * import of `SqlEngine`) so it is safe to import from BOTH the renderer and
 * the electron main process — e.g. `dashboards/services/crossFilter.ts` runs
 * in main via `tileExecutionIpc.ts`, which must not pull renderer
 * schema-cache modules into the electron bundle.
 */
import type { SqlEngine } from '../../features/sql-grammar/model';

const ENGINE_BY_DATABASE_ENGINE_ID: Readonly<Record<string, SqlEngine>> = {
  mssql: 'mssql',
  pgsql: 'postgres',
  mysql: 'mysql',
  oracle: 'oracle',
  sqlite: 'sqlite',
};

export function databaseEngineIdToSqlEngine(
  databaseEngineId: string | undefined,
): SqlEngine | null {
  if (!databaseEngineId) return null;
  return ENGINE_BY_DATABASE_ENGINE_ID[databaseEngineId] ?? null;
}
